export { default as Text } from './text';
export { default as useText } from './use-text';
//# sourceMappingURL=index.js.map